export const COMPONENT_MAP = {
  bespoke_block: "be-spoke",
  rte_block: "rte",
  eclub_block: "eclub",
  enterprise_cards_block: 'enterprise-cards',
  enterprise_faq_block: 'faqs',
  faq_section: 'faqs',
  promotional_card_section: 'promotional-cards',
  hero_section: 'hero-section',
  half_image_half_content_section: 'half-image-half-content',
  timeline_section: 'timeline-section',
  carousel_section: "carousel",
  nav_tabs_section: "nav-tabs-section",
  full_width_container: 'full-width-container',
  community_section: "community-section",
  parallax_section: "parallax-section",
  css_bespoke_block: "be-spoke",
  js_bespoke_block: "be-spoke",
};

export const SHARED_COMPONENT_MAP = {
  'be-spoke': true,
  'rte': true,
  'hero-section': true,
  'half-image-half-content': true,
  'timeline-section': true,
  'faq_section': true,
  'faqs': true,
  'promotional-cards': true,
  'full-width-container': true,
  'carousel': true,
  'nav-tabs-section': true,
  'community-section': true,
  'parallax-section': true
};

export const BRAND_CONTENT_TYPE = {
  default: 'generic_page',
  olivegarden: 'enterprise_generic_page',
  scheam: "brand_schema_configuration"
}

export const API_REF = {
  API_REF_CONSTANT_GENERIC_PAGE: [
    "modular_blocks.bespoke_block_ref.reference",
    "modular_blocks.banner_block.reference.heading_image",
    "modular_blocks.banner_block.reference.image",
    "modular_blocks.banner_block.reference.links",
    "modular_blocks.banner_block.reference.links.internal_page",
    "modular_blocks.banner_block.reference",
    "modular_blocks.banner_block.reference.video",
    "modular_blocks.banner_block.reference.banner",
    "modular_blocks.cards_block.reference.link",
    "modular_blocks.cards_block.reference.cards.image",
    "modular_blocks.cards_block.reference.cards.heading_image",
    "modular_blocks.cards_block.reference.cards.link.internal_page",
    "modular_blocks.cards_block.reference.cards.sub_link",
    "modular_blocks.cards_block.reference.cards.sub_card.image",
    "modular_blocks.cards_block.reference.cards.sub_card.link",
    "modular_blocks.rte_block.reference.rte",
    "modular_blocks.eclub_block.reference.link",
    "modular_blocks.eclub_block.reference.image",
    "modular_blocks.eclub_block.reference.additional_links",
    "modular_blocks.enterprise_cards_block.reference.enterprise_cards",
    "modular_blocks.enterprise_cards_block.reference.enterprise_card",
    "modular_blocks.enterprise_cards_block.reference.cards.image",
    "modular_blocks.enterprise_cards_block.reference.cards.link",
    "modular_blocks.enterprise_cards_block.reference.cards.social_media_icons.icon",
    "modular_blocks.enterprise_cards_block.reference.cards.social_media_icons.link",
    "modular_blocks.enterprise_cards_block.reference.links",
    "modular_blocks.enterprise_cards_block.reference.component_seo_schema",
    "modular_blocks.enterprise_banner_block.reference.enterprise_banner",
    "modular_blocks.enterprise_banner_block.reference.video",
    "modular_blocks.enterprise_banner_block.reference.links",
    "modular_blocks.enterprise_banner_block.reference.background_image",
    "modular_blocks.enterprise_banner_block.reference.carousel",
    "modular_blocks.enterprise_faq_block.reference.enterprise_faq",
    "modular_blocks.enterprise_faq_block.reference.list.enterprise_faq_item",
    "modular_blocks.faq_section.faq_schema",
    "modular_blocks.promotional_card_section",
    "modular_blocks.promotional_card_section.cards.image",
    "modular_blocks.promotional_card_section.cards.link",
    "modular_blocks.hero_section.reference.background_image.image",
    "modular_blocks.hero_section.reference.background_video.video",
    "modular_blocks.hero_section.reference.cta_group.cta_link.link",
    "modular_blocks.hero_section.reference.cta_group.cta_image.image",
    "modular_blocks.hero_section.reference.heading.heading_image.image",
    "modular_blocks.hero_section.reference.sub_heading.sub_heading_image.image",
    "modular_blocks.hero_section.reference.background_video.poster_image.image",
    "modular_blocks.half_image_half_content_section.reference.half_image_half_content",
    "modular_blocks.half_image_half_content_section.reference.background.background_image.image",
    "modular_blocks.half_image_half_content_section.reference.media.image",
    "modular_blocks.half_image_half_content_section.reference.cta_group.cta_link.link",
    "modular_blocks.half_image_half_content_section.reference.cta_group.cta_image.image",
    "modular_blocks.half_image_half_content_section.reference.heading.heading_image.image",
    "modular_blocks.half_image_half_content_section.reference.sub_heading.sub_heading_image.image",
    "modular_blocks.timeline_section.reference.timeline_item.content.logo.image",
    "modular_blocks.timeline_section.reference.timeline_item.content.image",
    "modular_blocks.full_width_container.reference.media.image",
    "modular_blocks.full_width_container.reference.media.sticky_heading",
    "modular_blocks.full_width_container.reference.cta_group.cta_link.link",
    "modular_blocks.full_width_container.reference.cta_group.cta_image.image",
    "modular_blocks.full_width_container.reference.heading.heading_image.image",
    "modular_blocks.full_width_container.reference.sub_heading.sub_heading_image.image",
    "modular_blocks.full_width_container.reference.social_media_icons.icon",
    "modular_blocks.full_width_container.reference.social_media_icons.link",
    "modular_blocks.carousel_section",
    "modular_blocks.carousel_section.carousel_items.image",
    "modular_blocks.carousel_section.carousel_items.link",
    "modular_blocks.community_section.reference",
    "modular_blocks.nav_tabs_section",
    "modular_blocks.nav_tabs_section.reference.tab_items.image",
    "modular_blocks.nav_tabs_section.reference.tab_items.link",
    "modular_blocks.nav_tabs_section.reference.tab_items.content.image",
    "modular_blocks.nav_tabs_section.reference.tab_items.content.cta_group.cta_link.link",
    "modular_blocks.nav_tabs_section.reference.tab_items.content.cta_group.cta_image.image",
    "modular_blocks.parallax_section.reference.section_items",
    "modular_blocks.parallax_section.reference.section_items.reference.full_width_container",
    "modular_blocks.parallax_section.reference.section_items.reference.social_media_icons",
    "modular_blocks.parallax_section.reference.section_items.reference.social_media_icons.icon",
    "modular_blocks.parallax_section.reference.section_items.reference.social_media_icons.link",
    "modular_blocks.parallax_section.reference.section_items.reference.cta_group.cta_link.link",
    "modular_blocks.parallax_section.reference.section_items.reference.cta_group.cta_image.image",
    "modular_blocks.parallax_section.reference.section_items.reference.heading.heading_image.image",
    "modular_blocks.parallax_section.reference.section_items.reference.sub_heading.sub_heading_image.image",

    "seo",
    "schema_configuration.enable_schema",
    "schema_configuration.schema_type",
    "schema_configuration.schema_strategy",
    "schema_configuration.custom_schema_json",
    "schema_configuration.brand_schema_configuration",
    "schema_configuration.web_page_schema",
  ],

  GLOBAL_HEADER_FOOTER_REF: [
    "header.additional_navigation",
    "header.additional_navigation_description",
    "header.left_navigation.internal_page",
    "header.right_navigation",
    "header.mobile_navigation",
    "header.cart_group.cart_logo",
    "header.cart_group.links",
    "header.cart_group.links.internal_page",
    "header.location_links",
    "header.location_links.internal_page",
    "header.logo",
    "header.mobile_change_location_link.link",
    "header.mobile_location_links.link",
    "header.mobile_select_location_link.link",
    "header.reserve_link",
    "header.reserve_logo",
    "header.global_banner_details",
    "header.global_banner_details.global_banner_link.link_reference",
    "footer.footer_rows.links.internal_page",
    "footer.footer_rows.icons",
    "footer.footer_rows.icons.icon",
    "footer.footer_rows.icons.link",
    "footer.footer_mobile_links",
    "footer.footer_columns.links.internal_page",
    "footer.footer_columns.icons.icon",
    "footer.footer_columns.icons.link",
    "reserve_table",
    "eclub.link",
    "eclub.image",
    "header.cart_group.cart_logo",
    "eclub.cards",
    "eclub.cards.image",
    "eclub.cards.link",
    "eclub.cards.sub_link",
  ],
  GENERIC_SETTINGS_KEY: "global_settings",
};

export const FIELD_REFERENCE_MAP = {
  genericPage: [
    "modular_blocks.bespoke_block_ref.reference",
    "modular_blocks.banner_block.reference.heading_image",
    "modular_blocks.banner_block.reference.image",
    "modular_blocks.banner_block.reference.links",
    "modular_blocks.banner_block.reference.banner",
    "modular_blocks.banner_block.reference.link",
    "modular_blocks.cards_block.reference.cards.image",
    "modular_blocks.cards_block.reference.cards.link",
  ],
  globalSettings: [
    "header.additional_navigation",
    "header.left_navigation.internal_page",
    "header.right_navigation",
    "header.mobile_navigation",
    "header.cart_logo",
    "header.logo",
    "footer.footer_rows.links.internal_page",
    "reserve_table",
    "eclub.link",
  ],
};
export const LIVE_PREVIEW_SETTINGS = {
  mode: "builder",
  enable: true,
  ssr: true,
  enableLivePreview: true,
  editButtonEnable: false,
  editButtonExclude: ["outsideLivePreviewPortal"],
  editButtonIncludeByQueryParameter: false,
  editButtonPosition: "top-right",
  editInVisualBuilderButtonEnable: false,
};
